document.addEventListener('DOMContentLoaded', () => {
  if (window.videoStoriesInitialized) return;
  window.videoStoriesInitialized = true;

  const modal = document.getElementById('VideoStoriesModal');
  if (!modal) return;

  const modalContent = modal.querySelector('.video-stories-modal__video-container');
  const closeBtn = modal.querySelector('.video-stories-modal__close');
  const backdrop = modal.querySelector('.video-stories-modal__backdrop');

  const muteBtn = modal.querySelector('.video-stories-modal__mute');
  const iconMuted = muteBtn.querySelector('.icon-muted');
  const iconUnmuted = muteBtn.querySelector('.icon-unmuted');

  let currentVideoElement = null;

  function updateMuteIcon(isMuted) {
    if (isMuted) {
      iconMuted.classList.remove('hidden');
      iconUnmuted.classList.add('hidden');
    } else {
      iconMuted.classList.add('hidden');
      iconUnmuted.classList.remove('hidden');
    }
  }

  // Alternar Mudo/Som
  muteBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    if (currentVideoElement) {
      currentVideoElement.muted = !currentVideoElement.muted;
      updateMuteIcon(currentVideoElement.muted);
    }
  });

  // Abrir Modal via delegação de eventos
  document.addEventListener('click', (e) => {
    const button = e.target.closest('.video-stories__button');
    if (!button) return;

    e.preventDefault();

    const videoType = button.dataset.videoType;
    const videoUrl = button.dataset.videoUrl;
    const shopifyVideoSrc = button.dataset.shopifyVideoSrc;
    const shopifyVideoType = button.dataset.shopifyVideoType;
    const customVideoUrl = button.dataset.customVideoUrl;

    let contentHTML = '';

    // Mostrar botão de mudo apenas para vídeos nativos (não iframes)
    muteBtn.style.display = (videoType === 'shopify' || videoType === 'custom') ? 'flex' : 'none';

    if (videoType === 'shopify' && shopifyVideoSrc) {
      contentHTML = `
        <video autoplay playsinline loop class="story-video">
          <source src="${shopifyVideoSrc}" type="${shopifyVideoType || 'video/mp4'}">
          Seu navegador não suporta o elemento de vídeo.
        </video>
      `;
    } else if (videoType === 'custom' && customVideoUrl) {
      contentHTML = `
        <video autoplay playsinline loop class="story-video">
          <source src="${customVideoUrl}" type="video/mp4">
          Seu navegador não suporta o elemento de vídeo.
        </video>
      `;
    } else if (videoUrl) {
      // YouTube
      if (videoUrl.includes('youtube') || videoUrl.includes('youtu.be')) {
        const ytMatch = videoUrl.match(/(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/shorts\/))([a-zA-Z0-9_-]{10,12})/);
        if (ytMatch) {
          const videoId = ytMatch[1];
          contentHTML = `<iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&loop=1&mute=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
        }
      } else if (videoUrl.includes('vimeo')) {
        const vimeoMatch = videoUrl.match(/vimeo\.com\/(\d+)/);
        if (vimeoMatch) {
          const videoId = vimeoMatch[1];
          contentHTML = `<iframe src="https://player.vimeo.com/video/${videoId}?autoplay=1&muted=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
        }
      } else {
        // Fallback: tratar como URL direta de vídeo
        muteBtn.style.display = 'flex';
        contentHTML = `
          <video autoplay playsinline loop class="story-video">
            <source src="${videoUrl}">
            Seu navegador não suporta o elemento de vídeo.
          </video>
        `;
      }
    }

    if (!contentHTML) return;

    const ctaLink = button.dataset.ctaLink;
    const ctaText = button.dataset.ctaText || 'Ver Coleção';
    if (ctaLink) {
      contentHTML += `
        <div class="video-stories-modal__cta" style="position: absolute; bottom: 24px; left: 24px; right: 24px; z-index: 20; display: flex; justify-content: center; pointer-events: auto;">
          <a href="${ctaLink}" class="video-stories-modal__cta-btn" style="background: #ffffff; color: #111111; text-decoration: none; padding: 14px 28px; border-radius: 50px; font-weight: 800; font-size: 14px; text-transform: uppercase; letter-spacing: 0.5px; box-shadow: 0 4px 20px rgba(0,0,0,0.4); width: 100%; text-align: center; display: block; transition: transform 0.2s ease;">${ctaText}</a>
        </div>
      `;
    }

    modalContent.innerHTML = contentHTML;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Capturar elemento de vídeo para controle de áudio
    currentVideoElement = modalContent.querySelector('video');

    if (currentVideoElement) {
      // Tentar tocar COM som automaticamente
      currentVideoElement.muted = false;
      currentVideoElement.play().then(() => {
        // Sucesso: vídeo tocando com áudio
        updateMuteIcon(false);
      }).catch(() => {
        // Fallback: navegador bloqueou autoplay com som
        // Recua para mudo e ativa o ícone de "Ativar Som"
        currentVideoElement.muted = true;
        currentVideoElement.play();
        updateMuteIcon(true);
      });
    } else {
      // Para iframes (YouTube/Vimeo) não temos controle de mute
      updateMuteIcon(false);
    }
  });

  // Fechar Modal
  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    modalContent.innerHTML = '';
    document.body.style.overflow = '';
    currentVideoElement = null;
  }

  closeBtn.addEventListener('click', closeModal);
  backdrop.addEventListener('click', closeModal);

  // Fechar com tecla Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });
});
